import { render, staticRenderFns } from "./AppTour.component.vue?vue&type=template&id=899e27e4&"
import script from "./AppTour.component.vue?vue&type=script&lang=js&"
export * from "./AppTour.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports